/** @jsx jsx */

// Packages
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';

// Local 
import fallbackImage from '../../../../../../sites/_shared/assets/SF-GREEN.png';

// CSS
import '../../Result/article.css';

export function TypeAheadBlogCard({ cardProps }) {
  const { result, layout, className, controller } = cardProps;

  const core = result?.mappings?.core

  //result.mappings.core.sku <-- This will help give you what type of content is being returned, if needed.
  
  const metafieldFeaturedImage = result?.attributes?.metafieldfeaturedimage;

  const imageUrl = core?.imageUrl ? core.imageUrl : metafieldFeaturedImage ? metafieldFeaturedImage : fallbackImage;
  const imageClass = imageUrl == fallbackImage ? 'ss__result__image-fallback' : '';

	return (
		<article
			className={classnames(
				'ss__result ss__result-article',
				typeof hoverImage != 'undefined' && 'ss__result__hover',
				`ss__result--${layout}`,
				className
			)}
		>
			<a
				href={core.url}
				onMouseDown={(e) => {
					controller?.track?.product?.click(e, result);
				}}
				className="ss__result-link"
				aria-label={core.name}
			>
				<div className="product-card-top-wrapper">
					<div className="ss__result__image-wrapper">
						<div className={classnames('ss__image', 'ss__result__image', `${imageClass}`)}>
							<img
								id={`ProductImage-${result.id}`}
								alt={core.name}
								class="product__img product__img--main lazyload"
								data-aspectratio="1.282258064516129"
								data-sizes="auto"
								data-image
								src={imageUrl}
							/>
						</div>
					</div>
					<div className="ss__result__details">
						{core.name && (
							<div
								className="ss__result__details__content-title"
								dangerouslySetInnerHTML={{
									__html: core.name,
								}}
							/>
						)}
					</div>
				</div>
			</a>
		</article>
	);
}
